import type { AnyAction, PayloadAction, Reducer } from '@reduxjs/toolkit';
import type { RefObject } from 'react';

// import { clear } from './editorScene';

// Raw reducer implementation allows us to transport React.RefObject similar to React.Context.

export type TAppRefsState = {
  viewerRef: RefObject<any> | null;
};

const initialState: TAppRefsState = {
  viewerRef: null,
};

// Attach clear life-cycle to sceneSlice reducer.
// const clearActionType = clear.type;
const setViewerRefActionType = 'appRefs/setViewerRef';

export const appRefsReducer: Reducer<TAppRefsState, AnyAction> = (state = initialState, action) => {
  switch (action.type) {
    // case clearActionType: {
    //   return { viewerRef: undefined };
    // }
    case setViewerRefActionType: {
      const viewerRef = (action as PayloadAction<TAppRefsState['viewerRef']>).payload;
      return { ...state, viewerRef };
    }
    default:
      return state;
  }
};

export const setViewerRef = (payload: RefObject<any> | null) => {
  return { type: setViewerRefActionType, payload };
};
